<template>
  <div v-if="show" class="loading-overlay-l">
    <div class="loading-box">
      <div class="spinner-container">
        <div class="dot"></div>
        <div class="dot" style="animation-delay: 0.2s"></div>
        <div class="dot" style="animation-delay: 0.4s"></div>
      </div>

      <h5 class="mt-3">{{ title }}</h5>
      <p class="text-muted">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: {
      type: String,
      default: "Caricamento in corso"
    },
    message: {
      type: String,
      default: "Attendere..."
    }
  }
}
</script>

<style scoped>

.loading-overlay-l {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-box {
  text-align: center;
  background: white;             
  padding: 2rem 2.5rem;
  border-radius: 12px;            
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  min-width: 250px;
}

/* Spinner dots */
.spinner-container {
  display: flex;
  justify-content: center;
}

.dot {
  width: 12px;
  height: 12px;
  margin: 0 5px;
  background-color: #0d6efd;
  border-radius: 50%;
  animation: bounce 1s infinite ease-in-out;
}

@keyframes bounce {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
}
.loading-overlay-l>* {
  animation: fadeIn 0.2s ease-in-out;
}


</style>